import { Box } from "@mui/joy";
import type { ReactNode } from "react";

import { Footer } from "../Footer/Footer";
import { Header } from "../Header/Header";

/**
 * Landing Layout with SaaS best practices for responsive design
 *
 * Breakpoints & Max Widths:
 * - Mobile (< 600px): 100% width, 16-20px padding
 * - Tablet (600-900px): 100% width, 24-32px padding
 * - Small Desktop (900-1200px): 100% width, 40-48px padding
 * - Large Desktop (1200-1536px): 1200px max-width, centered
 * - XL Desktop (> 1536px): 1400px max-width, centered
 *
 * These values follow industry standards from Stripe, Linear, Vercel
 */

interface LandingLayoutProps {
  children: ReactNode;
}

export const LandingLayout = ({ children }: LandingLayoutProps) => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        bgcolor: "background.body",
      }}
    >
      <Header addSpacer />
      <Box
        component="main"
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {children}
      </Box>
      <Footer />
    </Box>
  );
};
